import React from "react";
import { Page, Spinner, Box, InlineStack, Text } from '@shopify/polaris';

export default function BillingLoader({ message }: { message: string }) {
    return (
        <Page fullWidth title="Upsell Recommendations">
            <Box>
                <InlineStack align="center"><Spinner size="large" /></InlineStack>
                <Text as="p">{message}</Text>
            </Box>
        </Page>
    );
}
